/// <reference path="../types.d.ts" />
import history from '../history';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, commonEnums } from '@codametrix/ui-common';
import { api } from '../core/net';
import { showFeedback } from './ui';
import { Dictionary, DictionaryValues } from './action-types';
import { USER_ACTION_METADATA } from './action-constants';
import { syncActions as dictionaryValuesSyncActions } from './dictionary-values';
import { AmplifyCore } from '@codametrix/ui-common';
const { paginationUtils } = AmplifyCore;
const { DictionaryStatus } = commonEnums;
const chooseOrg = createAction(Dictionary.CHOOSE_ORG);
const chooseDictionary = createAction(Dictionary.CHOOSE_DICTIONARY);
const pushPath = createAction(Dictionary.PUSH_PATH);
const saveAssociatedDictionaries = createAction(Dictionary.SAVE_ASSOCIATED_DICTIONARIES);
const loadDictionaries = createAsyncThunk(Dictionary.TENANT_SELECTED, async (item, { dispatch })=>{
    const url = `/cmx/admin/orgs/${item.id}/dictionaries`;
    dispatch(chooseOrg(item));
    history.push(url);
    return item;
});
const loadDictionary = createAsyncThunk(Dictionary.SELECTED, async (params, { dispatch })=>{
    const { data: dictionary, path } = params;
    const searchParms = new URLSearchParams();
    searchParms.set('tenantId', dictionary.tenantId.uuid);
    const dictionaries = await api({
        endpoint: `/dictionary/${dictionary.name}/list/v2?${searchParms.toString()}`
    }) || [];
    dispatch(saveAssociatedDictionaries(dictionaries));
    const status = dictionary.editStatus === 'UPDATE' ? DictionaryStatus.DRAFT : dictionary.status.toLowerCase();
    dispatch(dictionaryValuesSyncActions.setStatusFilter(status));
    dispatch(chooseDictionary(dictionary.id));
    history.push(path);
    return dictionary;
});
const getDetail = createAsyncThunk(Dictionary.FETCH_DETAIL, async (id, { rejectWithValue, fulfillWithValue })=>{
    const userActionMeta = USER_ACTION_METADATA;
    if (id === undefined || id === null) {
        // TO REFACTOR - REMOVE ME.
        return fulfillWithValue({}, userActionMeta);
    }
    try {
        const detail = await api({
            endpoint: `/dictionary/${id}/dictionaryvalues/v2`
        });
        return fulfillWithValue(detail, userActionMeta);
    } catch (e) {
        return rejectWithValue(e, userActionMeta);
    }
}, {
    getPendingMeta: ()=>({
            ...USER_ACTION_METADATA
        })
});
const saveItem = createAsyncThunk(Dictionary.SAVE, async (item, { dispatch })=>{
    const isUpdate = item.id !== null;
    let method = isUpdate ? HttpMethods.PUT : HttpMethods.POST;
    const saved = await api({
        endpoint: `/dictionary/v2`,
        init: {
            method
        },
        body: item
    });
    return saved;
});
const updatePublishedMetadata = createAsyncThunk(Dictionary.UPDATE_PUBLISHED_METADATA, async (params, { dispatch })=>{
    const { dictionary, successPath } = params;
    const result = await dispatch(saveItem(dictionary)).unwrap();
    // route back to dictionary value list of new draft w/ updated metadata
    dispatch(loadDictionary({
        data: result,
        path: successPath
    }));
    if (result) {
        dispatch(showFeedback({
            id: Date.now(),
            message: `Metadata updated. Publish to finalize changes.`,
            dismissable: true
        }));
    }
    return result;
});
const listItems = createAsyncThunk(Dictionary.LIST, async (params)=>{
    const searchParams = paginationUtils.searchParamsFactory(params.sortablePageable);
    const pageableList = await api({
        endpoint: `/dictionary/v2?${searchParams.toString()}&tenantId=${params.id}&derivedIndicator=false&uniqueByName=true`,
        init: {
            method: HttpMethods.GET
        }
    });
    return pageableList;
});
const createTenantList = (org)=>{
    if (org === undefined) {
        return [];
    }
    const piece = {
        tenantName: org.organizationName,
        key: org.tenantId,
        id: org.id,
        organizationCode: org.organizationCode
    };
    var children = [];
    if (org.parentLevel !== 2) {
        org.children?.forEach((child)=>{
            children.push(...createTenantList(child));
        });
    }
    if (children !== undefined && children.length > 0) {
        return [
            piece,
            ...children
        ];
    }
    return [
        piece
    ];
};
const getTenantList = createAsyncThunk(DictionaryValues.TENANT, async (id)=>{
    const endpoint = isNaN(id) ? `/organization/tenant/v1?tenantId=${id}` : `/organization/id/v1?organizationId=${id}`;
    const orgOpts = {
        endpoint: endpoint
    };
    const organization = await api(orgOpts);
    const tenantList = createTenantList(organization).sort((a, b)=>{
        return a.tenantName.toUpperCase().localeCompare(b.tenantName.toUpperCase());
    });
    return tenantList;
});
export const syncActions = {
    chooseOrg,
    chooseDictionary,
    saveAssociatedDictionaries,
    pushPath
};
export { listItems, getDetail, saveItem, loadDictionary, getTenantList, loadDictionaries, updatePublishedMetadata };
